'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20.068 9.483c0-.299-.094-.541-.28-.728L18.36 7.357a.964.964 0 0 0-.7-.308.964.964 0 0 0-.7.308l-6.38 6.35-3.525-3.525a.964.964 0 0 0-.7-.308.964.964 0 0 0-.7.308L4.23 11.58c-.186.187-.28.43-.28.728 0 .28.094.513.28.699l5.653 5.65a.95.95 0 0 0 .7.28c.28 0 .522-.093.727-.28l8.479-8.475a.949.949 0 0 0 .28-.7ZM23.985 12c0 2.182-.531 4.186-1.595 6.014a11.945 11.945 0 0 1-4.365 4.364A11.697 11.697 0 0 1 12.009 24c-2.164 0-4.18-.54-6.045-1.622-1.865-1.082-3.311-2.537-4.337-4.364C.601 16.186.06 14.182.004 12c-.056-2.182.485-4.186 1.623-6.014 1.138-1.827 2.584-3.282 4.337-4.364C7.718.541 9.733 0 12.01 0s4.281.54 6.016 1.622c1.735 1.082 3.19 2.537 4.365 4.364 1.176 1.828 1.707 3.832 1.595 6.014Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
});
var OkCircled = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.OkCircled = OkCircled;